import React from "react";
import '../index.css';
const Footer = (props) => {
    return (
        <div className='footer'>
            <p> </p>
        </div>
    );
};
export default Footer;